import { useLotteryStore } from '#product/app/stores/lottery'

export default defineNuxtRouteMiddleware((to, from) => {
  const toPath = to.fullPath
  const fromPath = from.fullPath

  if (toPath !== fromPath) return

  const lotterIdParam = to.params?.lotteryId
  if (!lotterIdParam || typeof lotterIdParam !== 'string') return

  const lotteryId = getLotteryIdInCorrectCase(lotterIdParam)
  if (!lotteryId) return

  try {
    const { getCurrentPlays } = useLotteryStore()
    const { log } = useDatadog()

    const plays = getCurrentPlays(lotteryId)

    log('info', {
      appendPlayerInfo: true,
      component: 'log-editor-usage',
      message:
        plays && plays.length > 0
          ? `User restored plays on lottery ${lotteryId}`
          : `User visited lottery ${lotteryId} without plays`,
      messageContext: {
        lotteryId,
        numberOfRestoredPlays: plays?.length ?? 0,
        path: toPath,
        type: plays && plays.length > 0 ? 'restored' : 'visited',
      },
    })
  } catch {
    return
  }
})
